import {
  assign, createMachine, DoneInvokeEvent, sendParent,
} from 'xstate';
import {
  PreviewInterface, STATES, EVENTS, ACTIONS,
} from '../../interfaces/previewInterface';
import { EVENTS as WIDGET_EVENTS } from '../../interfaces/widgetInterface';

export const previewMachine = createMachine<PreviewInterface, DoneInvokeEvent<any>>({
  predictableActionArguments: true,
  id: 'previewMachine',
  context: {
    videosUrls: [],
  },
  initial: STATES.IDLE,
  states: {
    [STATES.IDLE]: {
      entry: [sendParent(WIDGET_EVENTS.GET_TAKES)],
      on: {
        [EVENTS.TAKES_RECEIVED]: {
          actions: [ACTIONS.SET_TAKES],
        },
      },
    },
    [STATES.ERROR]: {},
    [STATES.FINISH]: {
      type: 'final',
    },
  },
}, {
  actions: {
    [ACTIONS.SET_TAKES]: assign((context, event) => ({
      videosUrls: context.videosUrls.concat(event.data),
    })),
  },
});
